import { inject } from '@angular/core';
import { ApiServerService, NullResponse } from '../../core/api';
import { PiggyTransactionType } from './piggy.models';

const baseUrl = 'piggy';

export const injectPiggyApi = () => {
  const service = inject(ApiServerService);
  return {
    /** Solicita un retiro del saldo piggy hacia cuenta bancaria o monedero. */
    withdrawal: (data: PiggyWithdrawalRequest = null): Promise<PiggyWithdrawalResponse> => {
      const path = `${baseUrl}/withdrawal`;
      return service.call<PiggyWithdrawalResponse, PiggyWithdrawalRequest>(path, data);
    }
  };
};

export type PiggyWithdrawalResponse = NullResponse;

/**
 * Tipo para withdrawal (backend solo acepta BANK o WALLET):
 */
export type PiggyWithdrawalType = PiggyTransactionType.WALLET | PiggyTransactionType.BANK;

interface PiggyWithdrawalBaseRequest {
  userId: string;
  type: PiggyWithdrawalType;
}

export interface PiggyBankWithdrawalRequest extends PiggyWithdrawalBaseRequest {
  type: PiggyTransactionType.BANK;
  name: string;
  taxId: string;
  bankAccount: string;
  acceptanceId: string;
}

export interface PiggyWalletWithdrawalRequest extends PiggyWithdrawalBaseRequest {
  type: PiggyTransactionType.WALLET;
}

export type PiggyWithdrawalRequest = PiggyBankWithdrawalRequest | PiggyWalletWithdrawalRequest;
